import React, { useState } from 'react';

export default function HCard({ children, style: s, t }) {
  const [h, setH] = useState(false);
  return (
    <div
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      style={{
        background: t.card,
        border: `0.5px solid ${t.border}`,
        borderRadius: 20,
        transition: 'transform 0.35s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.35s',
        transform: h ? 'translateY(-4px)' : 'translateY(0)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        boxShadow: h ? '0 0 30px rgba(93,193,185,0.15)' : 'none',
        ...s,
      }}
    >
      {children}
    </div>
  );
}
